export default __webpack_public_path__ + "static/media/pic3.d9922a44.jpg";